import axios from 'axios';
/* 加法精度处理 */
export function numAdd(arg1, arg2) {
    let r1;
    let r2;
    let m;
    let c;
    try {
        r1 = arg1.toString().split('.')[1].length;
    }
    catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split('.')[1].length;
    }
    catch (e) {
        r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        let cm = Math.pow(10, c);
        if (r1 > r2) {
            arg1 = Number(arg1.toString().replace('.', ''));
            arg2 = Number(arg2.toString().replace('.', '')) * cm;
        } else {
            arg1 = Number(arg1.toString().replace('.', '')) * cm;
            arg2 = Number(arg2.toString().replace('.', ''));
        }
    } else {
        arg1 = Number(arg1.toString().replace('.', ''));
        arg2 = Number(arg2.toString().replace('.', ''));
    }
    return (arg1 + arg2) / m;
}

/* 累加计算送货总数 */
export function deliveryTotalCount(selection, key) {
    return selection.reduce((prev, next) => {
        return ((prev || prev === 0) && (next[key] || next[key] === 0) && numAdd(prev, next[key])) || 0;
    }, 0)
}

/* 根据字典与库存组织切换qms接口地址 */
export function qmsApiSwitch(_this, url, orgCode) {
    const orgObj = _this.$store.state.CUX_INT_QMS_ADDRESS.find((item) => item.code === orgCode);
    return orgObj ? url.replace('qms2gsc', orgObj.email) : url;
}

export function qmsApiSwitch2(_this, url, orgCode) {
    const orgObj = _this.$store.state.CUX_INT_QMS_ADDRESS.find((item) => item.code === orgCode);
    return orgObj ? (_this.isPro() ? orgObj.attribute1 : orgObj.attribute2) : url;
}

/* qms转换语言参数 */
export function switchLanguageToQms(lang) {
    switch (lang) {
        case 'zh-CN':
        return 'ZH_CN';
        break;
        case 'en-US':
        return 'EN_US';
        break;
        case 'th':
        return 'EN_TH';
        break;
    }
}

/* 导出excel */
export function exportExcel(url, data, fileName, _this, method = 'post') {
    return axios({
        url,
        method,
        data,
        params: method === 'get' ? data : undefined,
        headers: { 'content-type': 'application/json; charset=utf-8' },
        responseType: 'blob',
    })
        .then((res) => {
            const reader = new FileReader();
            reader.readAsText = res;
            _this.downloadFile(res.data, fileName || reader.readAsText.headers['content-disposition'].split('filename=')[1]);
        })
        .catch(() => {
            _this.showErrorTips();
        });
}

/* 深拷贝 */
export function deepCopy(source) {
    const sourceCopy = source instanceof Array ? [] : {};
    // eslint-disable-next-line no-restricted-syntax
    for (const item in source) {
        if (typeof source[item] === 'object') {
            if (source[item] === null) {
                sourceCopy[item] = null;
            } else {
                sourceCopy[item] = deepCopy(source[item]);
            }
        } else {
            sourceCopy[item] = source[item];
        }
    }
    return sourceCopy;
}

/* 获取组织编码 */
export function getOrgCode(orgList, val, findKeyName = 'erpOrgId', returnKeyName = 'organizationCode') {
    return (orgList.find((item) => item[findKeyName] === val) || {})[returnKeyName];
}

/* 导出多语言 */
export function langParams(lang) {
    switch (lang) {
    case 'zh-CN':
        return 'ZHS';
    case 'en-US':
        return 'US';
    case 'th':
        return 'TH';
    case 'vi':
        return 'VI';
    case 'ja-JP':
        return 'AR';
    default:
        return 'US';
    }
}

/* 海外域名标识 */
export function systemMark() {
    return {
        gschk: 'globalprotal',
        gsceu: 'gsceu',
        gscus: 'gscus',
        localhost: 'globalprotal',
    }[window.location.hostname.split('.')[0].replace(/sit|uat|ver/g, '')] || 'globalprotal';
}

/* 海外域名 */
export function intHostName(flag) {
    return {
        globalprotal: 'gschk',
        gsceu: 'gsceu',
        gscus: 'gscus',
    }[flag];
}

/* 海外系统标识集合 */
export const intSystems = ['globalprotal', 'gsceu', 'gscus'];
